<!--
 * @FileDescription: 新增售后单对话框
 * @Author: 陈文景
 * @Date: 2022-11-10 11:41:56
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <el-dialog title="新增售后单" :visible.sync="visible" width="680px" :before-close="close">
    <el-form :model="form" :rules="rules" ref="form" label-width="80px">
      <el-form-item label="售后类型" prop="type">
        <el-select v-model="form.type" size="medium" placeholder="请选择">
          <el-option label="退款" :value="0" />
          <el-option label="补偿" :disabled="true" :value="1" />
        </el-select>
      </el-form-item>
      <el-form-item label="Order Id" prop="kakaOrderId">
        <el-input v-model="form.kakaOrderId" size="medium" placeholder="请输入Kaka Order Id" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="medium" @click="close">取 消</el-button>
      <el-button size="medium" type="primary" @click="save">确 认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import API from '@/api'
let form = {
  type: 0,
  kakaOrderId: undefined
}

export default {
  data() {
    return {
      visible: false,

      form: { ...form },

      rules: {
        test: [{ required: true, message: '请选择售后类型', trigger: 'change' }],
        kakaOrderId: [{ required: true, message: '请输入Kaka Order Id', trigger: 'blur' }]
      }
    }
  },
  methods: {
    show() {
      this.visible = true
    },

    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.type === 0) {
            this.getRefundOrderInformation()
          }
        } else {
          return false
        }
      })
    },

    close() {
      this.clear()
      this.visible = false
    },

    clear() {
      this.form = { ...form }
      this.$refs.form.resetFields()
    },

    // 查看退款信息-新建退款单页面查询
    getRefundOrderInformation() {
      API.getRefundOrderInformation(this.form.kakaOrderId).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        if (res.data.paymentMethod === 8) {
          this.$message.warning('使用40Seas支付类型的订单暂不支持退款') 
        } else if (res.data.paymentMethod === 8 && ['fully_shipped', 'partial_shipped', 'completed'].includes(res.data.fulfillmentStatus) ) {
          this.$message.warning('使用40Seas支付类型的订单已存在发货不支持退款') 
        } else {
          this.$router.push({
            path: `/after-sale/after-sale/add-after-sale-refund-order`,
            query: { ...this.form }
          })
        }
        this.close()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
  /deep/ .el-input__suffix {
    height: 36px;
  }
}
</style>
